import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { screensData } from '../../data/screensData';

const GarminGpsmap8610xsv = () => {
  // Get the product data directly from screensData
  const productId = "gpsmap-8610xsv";
  const productData = screensData.find(item => item.id === productId);
  
  console.log('GarminGpsmap8610xsv - Direct Import - Product Data:', productData);
  console.log('GarminGpsmap8610xsv - Direct Import - Image URL:', productData?.image);
  
  // Use a direct image URL if we can't find one
  const imageUrl = productData?.image || "https://www.buildmyfishfinder.com/images/screens/garmin-gpsmap-8610xsv.jpg";
  
  return (
    <SimpleProductPage 
      specificProductId="gpsmap-8610xsv"
      productName="Garmin GPSMAP 8610xsv"
      productImage={imageUrl}
      csvLookupId="GPSMAP 8610xsv"
    />
  );
};

export default GarminGpsmap8610xsv; 